<template>
    <as-modal title="Security" @close="$emit('close', $event)">
        <p>
            AccountScore ensures your information is kept safe by using the same 256-bit encryption and
            physical security that banks use. Your banking username and password are immediately encrypted.
        </p>
        <p>
            AccountScore is only permitted ‘read-only’ access - no one can make any changes or payments using your details.
        </p>
    </as-modal>
</template>

<script>
    import AsModal from '../Ui/AsModal.vue';
    export default {
        name: 'Security',
        components: {
            AsModal,
        },
    };
</script>
